import React, { useEffect, useState }from 'react';
import { useDispatch, useSelector} from 'react-redux';
import Select, { components } from 'react-select';
import { selectTipoTransp } from '../../store/Transportadora';

const { ValueContainer, Placeholder } = components;

const SelectTipoFrete = ({ initialValue }) => {
  const dispatch = useDispatch();
  const selectTipoTransportadora = useSelector(state => state.transpReduce.selectTipoTransportadora);

  const optionsTipoFrete = [
    { label: "CIF", value: "C" },
    { label: "FOB", value: "F" }
  ];

  useEffect(() => {
    // dispatch(getTransp());
    if (initialValue) {
        const found = optionsTipoFrete.find(option => option.value === "C");
      dispatch(selectTipoTransp(found));
    }
  }, [dispatch, initialValue]);

  const CustomValueContainer = ({ children, ...props }) => (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );

  return (
    <div className="w-full my-2">
      <Select
        value={optionsTipoFrete.find(opt => opt.value === selectTipoTransportadora?.value) || null}
        onChange={(selectedOption) => {
          dispatch(selectTipoTransp(selectedOption ? selectedOption : null));
        }}
        isClearable={true}
        isSearchable={false}
        options={optionsTipoFrete}
        components={{ ValueContainer: CustomValueContainer }}
        placeholder="Tipo Frete"
        styles={{
          container: (provided) => ({
            ...provided,
            marginTop: 10
          }),
          valueContainer: (provided) => ({
            ...provided,
            overflow: "visible",
            marginTop: 20
          }),
          placeholder: (provided) => ({
            ...provided,
            position: "absolute",
            top: -15,
            backgroundColor: "transparent",
            fontSize: 14
          })
        }}
      />
    </div>
  );
};

export default SelectTipoFrete;
